import React, { useState, useEffect } from "react";
import { getSysInfo } from "../../services/dashApiService";
import { contact } from "../../configs/sysInfoConfig";
import { useContext } from "react";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";

export const Introduction = () => {
	const [sysInfo, setSysInfo] = useState(contact);
	useEffect(() => {
		let didCancel = false;
		getSysInfo()
			.then((result) => {
				if (result.success) {
					const data = result.data;
					if (!didCancel) {
						setSysInfo(data.contact);
					}
				} else {
					console.error(result.err);
				}
			})
			.catch((error) => {
				console.error("Error getting contact info: ", error);
			});

		return () => {
			didCancel = true;
		};
	}, []);

	const { theme } = useContext(DiseaseGroupContext);

	return (
		<div className={"text-md sm:text-md"}>
			<p className={"mb-4 sm:mb-6 text-lg sm:text-xl mt-8 font-light"}>
				We will quickly take you <br /> through some setup screens.
			</p>

			<p className="my-4 sm:my-8">These are to:</p>

			<ol className={`mb-8 md:mb-8 font-medium bracket-list font-bold `}>
				<li className={""}>Reconfirm contact details</li>
				<li className={""}>Reconfirm your consent</li>
			</ol>

			<p className={"mb-6"}>
				Please check all the fields. You will be able to go back to{" "}
				<span className="uppercase">setup</span> any time to check or change
				your answers.
			</p>

			<p className={"mb-6"}>
				If you're at all stuck at any time, please call or email Your Health
				Companion support on:
			</p>

			<p>
				<span className={"w-14 inline-block font-bold"}>Email:</span>
				<a href={`mailto:${sysInfo.email}`} className={"font-normal"}>
					{sysInfo.email}
				</a>
			</p>

			<p>
				<span className={"w-14 inline-block font-bold"}>Tel:</span>
				<a
					href={`tel:${sysInfo.telephone.replace(/\s+/g, "")}`}
					className={"font-normal"}
				>
					{sysInfo.telephone}
				</a>
			</p>
		</div>
	);
};
